class Faq {
    element = $('.js-faq');
    items: any;
  constructor() {
    $('.js-accessibility').hide();
    this.items = this.element.find('.js-item');
    let openItems;
    this.items.each((index, item) => {
        let items = $(item);
        let openItems = new FaqItems(items);
    });
  }
}



class FaqItems {
    element: any;
    content: any;

    constructor(items) {
        this.element = items;
        this.content = this.element.find('dd');
        this.element.on('mouseup', this.toggle.bind(this));
        this.element.removeClass('active');
    }
    toggle() {
        if(this.element.hasClass('active')) {
          this.element.removeClass('active');
        }else {
            $('.js-item.active').removeClass('active');
            this.element.addClass('active');
        }
    }

    close() {

    }

}

let faq = new Faq();
